module.exports = __webpack_public_path__ + "static/media/focus1.584d2bfd.jpg";